import { fieldStateKey, fieldInputType, fieldLabel, isFieldRequired } from '../../utils/dataFields';
import FieldLabel, { RequiredMark } from '../FieldLabel';

/**
 * Renders a list of possession fields generically (text / number / date / select /
 * textarea / boolean), bound to personalInfo by field id. Each field is a
 * `.form-group`; wrap the call site in a `.form-row` (flex-wrap) for layout.
 */
const PossessionFields = ({ fields, personalInfo, setPersonalInfo }) => {
  const setValue = (name, value) => setPersonalInfo((prev) => ({ ...prev, [name]: value }));

  return fields.map((field) => {
    const key = fieldStateKey(field);
    const value = personalInfo[key] || '';
    const flex = field.type === 'textarea' ? '1 1 100%' : '1 1 calc(50% - 8px)';
    return (
      <div className="form-group" key={field.id} style={{ flex }}>
        {field.type !== 'boolean' && <FieldLabel htmlFor={key} field={field} />}
        {field.type === 'boolean' ? (
          <label className="field-checkbox" htmlFor={key}>
            <input
              type="checkbox"
              id={key}
              name={key}
              checked={!!personalInfo[key]}
              onChange={(e) => setValue(key, e.target.checked)}
            />
            <span className="field-checkbox-box" />
            <span>{fieldLabel(field)}</span>
            {/* CIN-6871: the label WRAPS the checkbox here, so the mark goes inside it. */}
            {isFieldRequired(field) && <RequiredMark htmlFor={key} />}
          </label>
        ) : field.type === 'textarea' ? (
          <textarea
            id={key}
            name={key}
            value={value}
            onChange={(e) => setValue(key, e.target.value)}
            placeholder={field.placeholder || ''}
            required={!!field.required}
            rows={4}
            style={{ width: '100%', padding: '10px', resize: 'vertical', boxSizing: 'border-box' }}
          />
        ) : field.type === 'select' ? (
          <select
            id={key}
            name={key}
            value={value}
            onChange={(e) => setValue(key, e.target.value)}
            required={!!field.required}
          >
            <option value="">Select...</option>
            {(field.options || []).map((opt, i) => (
              <option key={i} value={opt}>
                {opt}
              </option>
            ))}
          </select>
        ) : (
          <input
            type={fieldInputType(field)}
            id={key}
            name={key}
            value={value}
            onChange={(e) => setValue(key, e.target.value)}
            placeholder={field.placeholder || ''}
            required={!!field.required}
          />
        )}
      </div>
    );
  });
};

export default PossessionFields;
